import React from 'react';
import MaxLengthCounter from './MaxLengthCounter';
import autosize from 'autosize';
import classNames from 'classnames';
import './TextAreaField.styl';

export default class TextAreaField extends React.PureComponent {
  componentDidMount() {
    // the html 5 version of this prop is 'autofocus' so use that going forward
    if (this.props.focused || this.props.autoFocus) {
      this.inputRef.focus();
      this.inputRef.selectionEnd = this.inputRef.value.length;
    }
  }

  handleChange = event => {
    const value = event.target.value;
    this.props.onChange(value);
  };

  render() {
    const {
      // eslint-disable-next-line
      focused,
      // eslint-disable-next-line
      onChange,
      onBlur,
      // eslint-disable-next-line
      onError,
      inputRef,
      value,
      maxLength,
      ...extraProps
    } = this.props;

    const className = classNames('ev-text-area-field ev-input', {
      'max-length-visible': maxLength && value && value.length > 0,
    });

    return (
      <div className={className}>
        <textarea
          ref={ref => {
            inputRef && inputRef(ref);
            autosize(ref);
            this.inputRef = ref;
          }}
          className="field-input"
          onChange={this.handleChange}
          onBlur={onBlur}
          value={value}
          maxLength={maxLength}
          {...extraProps}
        />
        <MaxLengthCounter maxLength={maxLength} value={value} />
      </div>
    );
  }
}
